

export default umd;
import packageResult from 'utils/packageResult';
import umdIntro from 'utils/umd/umdIntro';
import requireName from 'utils/umd/requireName';
function umd(bundle, options) {
	requireName(options);

	var entry = bundle.entryModule;

	var intro = umdIntro({
		hasExports: entry.exports.length > 0,
		imports: bundle.externalModules,
		amdName: options.amdName,
		name: options.name,
		indentStr: bundle.body.getIndentString(),
		useStrict: options.useStrict !== false
	});

	if (entry.defaultExport) {
		bundle.body.append('\n\nreturn ' + entry.identifierReplacements['default'] + ';');
	}

	bundle.body.indent().prepend(intro).trimLines().append('\n\n}));');

	return packageResult(bundle, bundle.body, options, 'toUmd', true);
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/bundler/builders/defaultsMode/umd.js.01-babel.map